import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { setHighestZIndexForOpenModals } from '../../../../util/common-utils'
import { TransactionConstants } from '../../../../util/constants'

@Component({
  selector: 'hs-save-confirm-modal',
  template: `
    <div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">Warning!</h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        ngbTooltip="Close"
        (click)="activeModal.close()"
      >
        Close
      </button>
    </div>
    <div class="modal-body" hsDraggable="modal-dialog">
      <p>
        <b> Do not proceed without explicit confirmation!</b> <br />
        The transfers you are about to submit are between different Ultimate
        Parent Clients. This should only be done under extraordinary
        circumstances. If you are not sure whether you should do this, do not
        submit your commands.
      </p>
    </div>
    <div class="modal-footer" hsDraggable="modal-dialog">
      <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
      <button nf-button="submit" (click)="activeModal.close(true)">
        Acknowledge
      </button>
    </div>
  `,
})
export class DirectTransferSaveConfirmationModalComponent implements OnInit {
  @Input() saveModalInput?: string

  readonly compId = TransactionConstants.CONFIRM_BUTTON_COMP_ID

  constructor(
    public activeModal: NgbActiveModal,
    private readonly eleRef: ElementRef,
  ) {}

  ngOnInit() {
    setHighestZIndexForOpenModals(this.compId, this.eleRef)
  }

  getComponentId() {
    return this.compId
  }
}
